module.exports = __webpack_public_path__ + "img/product_banner_02.3c5f7cf9.jpg";